import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { googleSession } from "@/lib/account-api";
import { useAccount } from "@/lib/account";

export const AuthCallback = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAccount();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    const back = window.sessionStorage.getItem("lunelle-after-login") || "/";
    window.sessionStorage.removeItem("lunelle-after-login");
    googleSession(sessionId)
      .then((u) => { setUser(u); toast(`Welcome, ${u?.name ?? "friend"}`, { description: "Your calendar now saves to your account." }); })
      .catch(() => toast.error("Google sign-in didn't finish. Please try again."))
      .finally(() => navigate(back, { replace: true }));
  }, [hash, navigate, setUser]);
  return <div className="min-h-screen" data-testid="auth-callback" />;
};
